/**
 * Cookie utility functions for secure token storage
 */

const REFRESH_TOKEN_KEY = "graph_refresh_token";
const REFRESH_TOKEN_EXPIRY_DAYS = 14; // Refresh tokens typically last 14 days

/**
 * Set a cookie with specified name, value, and expiry days
 */
export const setCookie = (name: string, value: string, days: number): void => {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  // Secure and SameSite for security
  document.cookie =
    name +
    "=" +
    encodeURIComponent(value || "") +
    expires +
    "; path=/; Secure; SameSite=None";
};

/**
 * Get a cookie value by name
 */
export const getCookie = (name: string): string | null => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) {
      return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
  }
  return null;
};

/**
 * Delete a cookie by name
 */
export const eraseCookie = (name: string): void => {
  document.cookie =
    name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; Secure; SameSite=None";
};

/**
 * Save refresh token to cookie
 */
export const saveRefreshToken = (refreshToken: string): void => {
  setCookie(REFRESH_TOKEN_KEY, refreshToken, REFRESH_TOKEN_EXPIRY_DAYS);
};

/**
 * Get refresh token from cookie
 */
export const getRefreshToken = (): string | null => {
  return getCookie(REFRESH_TOKEN_KEY);
};

/**
 * Clear refresh token from cookie
 */
export const clearRefreshToken = (): void => {
  eraseCookie(REFRESH_TOKEN_KEY);
};
